import { render, staticRenderFns } from "./fbgx.vue?vue&type=template&id=780c4768"
import script from "./fbgx.vue?vue&type=script&lang=js"
export * from "./fbgx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports